import { render, staticRenderFns } from "./PublicationArticle.vue?vue&type=template&id=69bc812e&scoped=true&"
import script from "./PublicationArticle.vue?vue&type=script&lang=ts&"
export * from "./PublicationArticle.vue?vue&type=script&lang=ts&"
import style0 from "./PublicationArticle.vue?vue&type=style&index=0&id=69bc812e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69bc812e",
  null
  
)

export default component.exports